import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Navbar from '../../../components/Navbar';
import Background from '../../../components/Background';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import style from './FluxogramaAtendimento.module.css';
import OgmoSantos from './OGMO-SANTOS.png'; // Caminho da imagem
import GuardaPortuaria from './Guarda_Portuaria.png'; // Caminho da imagem
import PAM from './PAM.png'; // Caminho da imagem
import CorpoBombeiros from './Corpo_De_Bombeiros.png'; // Caminho da imagem

const FluxogramaAtendimento = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar motivados />
      <Header />
      <Background />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div onClick={() => navigate("")}>
              Segurança do Trabalho &gt;&gt; FLUXOGRAMA DE ATENDIMENTO A EMERGÊNCIA
            </div>
          </div>

          <div className={style.fluxograma}>
            <h2>Fluxograma para Comunicação em Caso de Ocorrência</h2>

            {/* Passo 1: Acidente Com/Sem Vítima */}
            <div className={style.step2}>
              <div className={style.stepNumber}>1</div>
              <div className={style.stepContent}>
                <center><h3>Acidente Com/Sem Vítima - SEM necessidade de remoção para hospital</h3></center>
                <p><strong>Gerente:</strong>
                  <a href="tel:13997611390" className={style.acionarBtn}>
                    José Rodrigues - (13) 99761-1390
                  </a></p>
                <p><strong>Segurança do Trabalho:</strong>
                  <a href="tel:13997505463" className={style.acionarBtn}>
                    Natália Lopes - (13) 99750-5463
                  </a></p>
              </div>

            </div>

            {/* Passo 2: Acidente Ambiental */}
            <div className={style.step}>
              <div className={style.stepNumber}>1</div>
              <div className={style.stepContent}>
                <center><h3>Acidente Com Vítima - Necessidade de remoção para hospital </h3></center>

                <p><strong>Avaliar a Situação</strong></p>

                <p>Observe e analise o ocorrido de forma segura,
                  mantendo uma distância adequada. Caso exista risco de envolver
                  mais pessoas na ocorrência, evite se aproximar e impeça que outros
                  se aproximem até que o local esteja seguro. Identifique os detalhes
                  importantes, como a natureza do incidente e as condições da vítima,
                  para que você possa fornecer informações precisas ao acionar a
                  ambulância ou a equipe médica.</p>

                <p><strong>Acionar Equipe Médica</strong></p>

                <p>A pessoa que assumir o papel de líder da ocorrência deve imediatamente
                  ligar para a equipe médica da Medicar (0800.941.5455), informando com
                  clareza as condições da vítima. Se o incidente ocorrer no porão de um
                  navio, é crucial destacar essa informação, pois a Medicar enviará uma
                  equipe especializada para acessar essa área</p>

                <p><strong>Ambulância:</strong>
                  <a href="tel:08009415455" className={style.acionarBtn}>
                    MEDICAR - 0800.941.5455
                  </a></p>


                <table className={style.employeeTable}>
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th>Informação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Funcionários da Orion ou terceiros</td>
                      <td>ID: 002326810</td>
                    </tr>
                    <tr>
                      <td>Funcionários do OGMO</td>
                      <td>Trabalhador vinculado ao OGMO</td>
                    </tr>
                  </tbody>
                </table>

                <p><strong>Líder da ocorrência destina um colaborador para informar a ocorrência</strong></p>

                <p><strong>Gerente:</strong>
                  <a href="tel:13997611390" className={style.acionarBtn}>
                    José Rodrigues - (13) 99761-1390
                  </a></p>
                <p><strong>Segurança do Trabalho:</strong>
                  <a href="tel:13997505463" className={style.acionarBtn}>
                    Natália Lopes - (13) 99750-5463
                  </a></p>

              </div>
            </div>

            {/* Passo 3: Incêndio */}
            <div className={style.step}>
              <div className={style.stepNumber}>2</div>
              <div className={style.stepContent}>
                <center><h3><strong>Organização do Acesso para a Ambulância</strong> </h3></center>
                <p>
                  O líder da ocorrência deve designar uma pessoa especificamente para coordenar o
                  acesso da ambulância até o local do incidente. Isso inclui ir até o portão de entrada
                  (Gate) e comunicar a <strong>Guarda Portuária (13 3202.6570)</strong>, garantindo que o caminho esteja
                  livre e que a equipe de resgate tenha acesso rápido e desobstruído. essa pessoa também
                  é responsável por ligar no plantão da Guarda Portuária e informar a ocorrência.</p>
                <div className={style.bombeiros}>
                  <img src={GuardaPortuaria} alt="Guarda Portuaria" className={style.bombeirosLogo} />
                  <a href="tel:1332026570" className={style.acionarBtn}>
                    Acionar Guarda Portuaria
                  </a>
                </div>
              </div>
            </div>

            {/* Contatos finais */}
            <div className={style.step}>
              <div className={style.stepNumber}>3</div>
              <div className={style.stepContent}>
                <center><h3><strong>Apoio à Vítima</strong> </h3></center>
                <p>
                  Se o líder da ocorrência constatar que não há mais riscos no local, ele deve designar
                  um colaborador para permanecer ao lado da vítima até a chegada da ambulância, oferecendo
                  suporte e observando possíveis mudanças no estado da vítima para informar a equipe médica
                  ao chegar.</p>

              </div>
            </div>

            <div className={style.step}>
              <div className={style.stepNumber}>4</div>
              <div className={style.stepContent}>
                <center><h3><strong>Ocorrência no Porão do Navio</strong> </h3></center>
                <p>
                  O líder da emergência deve acionar imediatamente a equipe de manutenção para desconectar
                  o grab e conectar o cesto de regate  ao guincho do navio. Em seguida, deve solicitar ao
                  guincheiro que baixe o lançamento, para que essa atividade seja realizada.
                </p>
              </div>
            </div>

            <div className={style.step}>
              <div className={style.stepNumber}>5</div>
              <div className={style.stepContent}>
                <center><h3><strong>Ocorrência com TPA</strong> </h3></center>
                <p>
                O líder da emergência deve notificar imediatamente o plantão de segurança do trabalho 
                (13 97418-5718) do OGMO, informando todos os detalhes da ocorrência para que as medidas
                 de segurança e suporte sejam tomadas imediatamente.
                </p>

                <div className={style.bombeiros}>
                  <img src={OgmoSantos} alt="OGMO" className={style.bombeirosLogo} />
                  <a href="tel:13974185718" className={style.acionarBtn}>
                    Acionar OGMO Santos
                  </a>
                </div>
              </div>
            </div>

            {/* Acidente Ambiental e Incêndio (Two columns with icons) */}
            <div className={style.twoColumns}>
              {/* Acidente Ambiental */}
              <div className={style.column}>
                <div className={style.columnHeader}>
                  <i className="fas fa-leaf"> Acidente Ambiental</i> {/* FontAwesome icon for environmental issues */}

                </div>
                <p>1º Passo: Vazamento de óleo/diesel no Costado, utilizar o Kit Ambiental, registrar a ocorrência com fotos e enviar para José Rodrigues e Natália Lopes.</p>
                <p>2º Passo: Vazamento de óleo/produto no mar, acionar José Rodrigues e Natália Lopes.</p>
              </div>

              {/* Incêndio */}
              <div className={style.columnIncendio}>
                <div className={style.columnHeaderIncendio}>
                  <i className="fas fa-fire"> Incêndio</i> {/* FontAwesome icon for fire incidents */}
                </div>
                <p>1º Passo: Iniciar o combate ao foco do princípio de incêndio com os meios de intervenção existentes.</p>
                <p>2º Passo: Se não tiver sucesso, acionar imediatamente o Corpo de Bombeiros (193) e PAM do Porto (3202-6565).</p>
                <p>3º Passo: Evacuar o local e encaminhar os ocupantes para o ponto de encontro (GATE mais próximo).</p>
              
                <div className={style.bombeiros}>
                  <img src={CorpoBombeiros} alt="CORPOBOMBEIROS" className={style.bombeirosLogo} />
                  <a href="tel:193" className={style.acionarBtnn}>
                    Acionar OGMO Santos
                  </a>
                  <img src={PAM} alt="PAM" className={style.bombeirosLogo} />
                  <a href="tel:1332026565" className={style.acionarBtnn}>
                    Acionar PAM
                  </a>
                </div>
                
              </div>
            </div>

          </div>
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <FluxogramaAtendimento />
    </SnackbarProvider>
  );
}
